import { DATA } from 'app/constants';
import Data from 'endpoints/data';

const setUserCountries = (payload) => {
  return { type: DATA.SET_USER_COUNTRIES, payload };
};

const setUserRoles = (payload) => {
  return { type: DATA.SET_USER_ROLES, payload };
};

const getUserCountriesThunk = () => async (dispatch, getState) => {
  try {
    const response = await Data.getUserCountries();
    const data = response.map(item => ({ value: item.code, label: item.name }))
    dispatch(setUserCountries(data));
  } catch (error) {
    console.error('[getUserRolesThunk][error]:', error);
  }
};

const getUserRolesThunk = () => async (dispatch, getState) => {
  try {
    const response = await Data.getUserRoles();
    dispatch(setUserRoles(response));
  } catch (error) {
    console.error('[getUserRolesThunk][error]:', error);
  }
};

export default {
  setUserRoles,
  setUserCountries,
  getUserRolesThunk,
  getUserCountriesThunk,
}